
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'CurrentUser',
    ])
  },
  watch: {
    CurrentUser() {
      this.setBrazeUser(this.CurrentUser)
    }
  },
  mounted() {
    this.setBrazeUser(this.CurrentUser)
  },
  methods: {
    setBrazeUser(currentUser) {
      if (!currentUser) {
        return;
      }
      const uuid = currentUser.UserId;
      const { braze } = window;

      if (braze?.changeUser) {
        braze.changeUser(uuid);
      } else {
        window.preloadBrazeUserId = uuid;
      }
    }
  }
};
